const dateTime = new Intl.DateTimeFormat("en-GB", { dateStyle: "medium", timeStyle: "short" });
const date = new Intl.DateTimeFormat("en-GB", { dateStyle: "medium" });
const relative = new Intl.RelativeTimeFormat("en", { numeric: "auto" });

export const formatDateTime = (iso: string) => dateTime.format(new Date(iso));
export const formatDate = (iso: string) => date.format(new Date(iso));

/** "3 minutes ago", "yesterday", falling back to a date after a month. */
export function ago(iso: string, now = Date.now()): string {
  const seconds = Math.round((new Date(iso).getTime() - now) / 1000);
  const abs = Math.abs(seconds);
  if (abs < 45) return "just now";
  if (abs < 3600) return relative.format(Math.round(seconds / 60), "minute");
  if (abs < 86400) return relative.format(Math.round(seconds / 3600), "hour");
  if (abs < 30 * 86400) return relative.format(Math.round(seconds / 86400), "day");
  return formatDate(iso);
}

/** How an audit action reads in the record. */
export function describeAction(action: string): string {
  return (
    {
      "ops.sign_in": "Signed in to the ops panel",
      "account.create": "Created an account",
      "account.update": "Changed an account",
      "account.disable": "Disabled an account",
      "account.enable": "Enabled an account",
      "account.password_reset": "Reset a password",
      "account.two_step_reset": "Turned off two-step sign-in",
      "account.sessions_end": "Signed an account out everywhere",
      "account.session_end": "Ended a browser session",
      "client.create": "Registered a portal",
      "client.update": "Changed a portal",
      "client.secret_rotate": "Made a new portal secret",
      "client.disable": "Disabled a portal",
      "client.enable": "Enabled a portal",
      "client.account_add": "Gave an account access to a portal",
      "client.account_remove": "Took away an account's portal access",
      "settings.sms": "Changed the SMS settings",
    }[action] ?? action
  );
}
